import React, { useEffect, useState } from "react";

import airPressure from "../asset/airPressure.svg";
import dewPoint from "../asset/dewPoint.svg";
import humidity from "../asset/humidity.svg";
import uvIndex from "../asset/uvIndex.svg";
import windSpeed from "../asset/windSpeed.svg";

const LeftMenu = ({ s_data, s_hoverPlant }) => {
  // if (!s_hoverPlant) return "";

  const leftMenu = [
    {
      icon: humidity,
      title: "濕度",
      subtitle: "Humidity",
      value: s_data[s_hoverPlant]?.humidity,
      key: "humidity",
    },
    {
      icon: airPressure,
      title: "氣壓",
      subtitle: "Air Pressure",
      value: s_data[s_hoverPlant]?.airPressure,
      key: "airPressure",
    },
    {
      icon: windSpeed,
      title: "風速",
      subtitle: "Wind Speed",
      value: s_data[s_hoverPlant]?.windSpeed,
      key: "windSpeed",
    },
    {
      icon: uvIndex,
      title: "紫外線指數",
      subtitle: "UV Index",
      value: s_data[s_hoverPlant]?.uvIndex,
      key: "uvIndex",
    },
    {
      icon: dewPoint,
      title: "露點溫度",
      subtitle: "Dew Point",
      value: s_data[s_hoverPlant]?.dewPoint,
      key: "dewPoint",
    },
  ];
  console.log("s_data = ", s_data);
  return (
    <section className="absolute top-[150px] left-[30px] w-[300px] flex flex-col items-center gap-[20px] 2xl:gap-[30px]">
      {leftMenu.map((item, index) => (
        <div key={index} className="left-card  z-[9999]">
          <img src={item.icon} alt={item.name} />
          <div className="flex flex-col pl-3 flex-1">
            <span className="left-card-title">{item.title}</span>
            <span className="subtitle">{item.subtitle}</span>
          </div>
          <span className="text-2xl flex-1 pl-3 text-white text-right mr-2">{item.value}</span>
        </div>
      ))}
    </section>
  );
};

export default LeftMenu;
